import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

interface GuideSectionProps {
  id: string;
  title: string;
  description?: string;
  icon: LucideIcon;
  children: ReactNode;
}

export function GuideSection({ id, title, description, icon: Icon, children }: GuideSectionProps) {
  return (
    <section id={id} className="scroll-mt-28">
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
        {/* Header with gradient icon */}
        <div className="flex items-center gap-4 px-6 py-5 border-b border-slate-100">
          <div className="w-10 h-10 rounded-lg bg-brand-gradient flex items-center justify-center shrink-0">
            <Icon className="w-5 h-5 text-white" />
          </div>
          <div>
            <h2 className="text-lg font-bold text-slate-900">{title}</h2>
            {description && <p className="text-sm text-slate-500 mt-0.5">{description}</p>}
          </div>
        </div>

        {/* Content */}
        <div className="px-6 py-5 space-y-6">
          {children}
        </div>
      </div>
    </section>
  );
}
